import { render, staticRenderFns } from "./SystemMessageServicePurchase.vue?vue&type=template&id=5ce51dc6&scoped=true&"
import script from "./SystemMessageServicePurchase.vue?vue&type=script&lang=ts&"
export * from "./SystemMessageServicePurchase.vue?vue&type=script&lang=ts&"
import style0 from "./SystemMessageServicePurchase.vue?vue&type=style&index=0&id=5ce51dc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce51dc6",
  null
  
)

export default component.exports